export default `제1조. 개인정보처리방침

“개인정보처리방침”이란 회원이 프리플랍 서비스를 안심하고 이용할 수 있도록 회사가 준수해야 할 기본적인 원칙과 지침을 의미합니다. 프리플랍은 개인정보 처리자로서 『개인정보 보호법』을 비롯한 대한민국의 관련 법령, 개인정보 보호 규정 및 가이드라인을 충실히 따르며 개인정보처리방침을 제공합니다.

프리플랍은 회원의 동의를 기반으로 개인정보를 수집·이용·제공하고 있으며, 개인정보 자기결정권이라는 회원의 중요한 권리를 보호하기 위해 노력합니다.

제2조. 개인정보 수집

프리플랍은 이용자가 회원가입을 하지 않아도 홀덤 대회 정보 검색, 뉴스 및 미디어 콘텐츠 열람 등 기본적인 서비스를 자유롭게 이용할 수 있도록 제공하고 있습니다. 다만, 대회 등록, 커뮤니티 활동, 포인트 적립 및 이벤트 참여 등 개인화된 기능 또는 회원제 서비스 이용을 원하는 경우에는, 프리플랍은 서비스 제공을 위해 필요 최소한의 개인정보를 수집합니다.

회원가입 시점에 네이버가 이용자로부터 수집하는 개인정보는 아래와 같습니다.

- 회원 가입 시 필수항목으로 아이디, 비밀번호, 이름, 생년월일, 휴대전화번호를, 선택항목으로 본인확인 이메일주소를 수집합니다.
- 파트너사 회원가입 시 필수 항목으로 단체아이디, 비밀번호, 단체이름, 이메일주소, 휴대전화번호를, 선택항목으로 단체 대표자명을 수집합니다.

서비스 이용 과정에서 이용자로부터 수집하는 개인정보는 아래와 같습니다.

- 회원정보 또는 개별 서비스에서 프로필 정보(별명, 프로필 사진)를 설정할 수 있습니다. 회원정보에 별명을 입력하지 않은 경우에는 마스킹 처리된 아이디가 별명으로 자동 입력됩니다.
- 프리플랍 내의 개별 서비스 이용, 이벤트 응모 및 경품 신청 과정에서 해당 서비스의 이용자에 한해 추가 개인정보 수집이 발생할 수 있습니다.

서비스 이용 과정에서 IP 주소, 쿠키, 서비스 이용 기록, 기기정보, 위치정보가 생성되어 수집될 수 있습니다.

프리플랍은 아래의 방법을 통해 개인정보를 수집합니다.

- 회원가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우, 해당 개인정보를 수집합니다.
- 고객센터를 통한 상담 과정에서 웹페이지, 메일, 팩스, 전화 등을 통해 이용자의 개인정보가 수집될 수 있습니다.
- 오프라인에서 진행되는 이벤트, 세미나 등에서 서면을 통해 개인정보가 수집될 수 있습니다.
- 프리플랍 제휴한 외부 기업이나 단체로부터 개인정보를 제공받을 수 있으며, 이러한 경우에는 개인정보보호법에 따라 제휴사에서 이용자에게 개인정보 제공 동의 등을 받은 후에 프리플랍에 제공합니다.
- 기기정보와 같은 생성정보는 PC웹, 모바일 웹/앱 이용 과정에서 자동으로 생성되어 수집될 수 있습니다.

제3조. 수집한 개인정보의 이용

프리플랍은 수집한 개인정보를 아래의 목적에 한하여 이용하며, 이용자의 사전 동의 없이 본 목적 외의 용도로 사용하지 않습니다. 회사는 이용자가 안심하고 서비스를 이용할 수 있도록 회원관리, 서비스 제공 및 개선, 커뮤니티 운영, 안정적인 서비스 환경 구축을 위한 최소한의 범위 내에서 개인정보를 이용합니다.

- 회원 가입 의사의 확인, 이용자 본인 확인, 이용자 식별, 회원탈퇴 의사의 확인 등 회원관리를 위하여 개인정보를 이용합니다.
- 콘텐츠 등 기존 서비스 제공(광고 포함)에 더하여, 인구통계학적 분석, 서비스 방문 및 이용기록의 분석, 개인정보 및 관심에 기반한 이용자간 관계의 형성, 지인 및 관심사 등에 기반한 맞춤형 서비스 제공 등 신규 서비스 요소의 발굴 및 기존 서비스 개선 등을 위하여 개인정보를 이용합니다. 신규 서비스 요소의 발굴 및 기존 서비스 개선 등에는 정보 검색, 다른 이용자와의 커뮤니케이션, 콘텐츠 생성·제공·추천, 상품 쇼핑 등에서의 인공지능(AI) 기술 적용이 포함됩니다.
- 법령 및 프리플랍 이용약관을 위반하는 회원에 대한 이용 제한 조치, 부정 이용 행위를 포함하여 서비스의 원활한 운영에 지장을 주는 행위에 대한 방지 및 제재, 계정도용 및 부정거래 방지, 약관 개정 등의 고지사항 전달, 분쟁조정을 위한 기록 보존, 민원처리 등 이용자 보호 및 서비스 운영을 위하여 개인정보를 이용합니다.
- 유료 서비스 제공에 따르는 본인인증, 구매 및 요금 결제, 상품 및 서비스의 배송을 위하여 개인정보를 이용합니다.
- 이벤트 정보 및 참여기회 제공, 광고성 정보 제공 등 마케팅 및 프로모션 목적으로 개인정보를 이용합니다.
- 서비스 이용기록과 접속 빈도 분석, 서비스 이용에 대한 통계, 서비스 분석 및 통계에 따른 맞춤 서비스 제공 및 광고 게재 등에 개인정보를 이용합니다.
- 보안, 프라이버시, 안전 측면에서 이용자가 안심하고 이용할 수 있는 서비스 이용환경 구축을 위해 개인정보를 이용합니다.

제4조. 개인정보의 제공 및 위탁

프리플랍은 이용자의 사전 동의 없이 개인정보를 외부에 제공하지 않습니다. 단, 이용자가 외부 제휴사의 서비스를 이용하기 위하여 개인정보 제공에 직접 동의를 한 경우 또는 대회 또는 기타 이벤트에 의해 제삼자에게 사용자의 정보를 제공해야하는 경우, 그리고 관련 법령에 의거해 프리플랍에 개인정보 제출 의무가 발생한 경우, 이용자의 생명이나 안전에 급박한 위험이 확인되어 이를 해소하기 위한 경우에 한하여 개인정보를 제공하고 있습니다.

제5조. 개인정보의 파기

회사는 원칙적으로 회원의 개인정보 수집 및 이용 목적이 달성되거나, 회원이 탈퇴하는 경우 지체 없이 해당 개인정보를 파기합니다.

다만, 다음 각 호에 해당하는 경우에는 관련 법령에 따라 일정 기간 동안 개인정보를 안전하게 보관할 수 있습니다:

- 회원으로부터 별도의 보관 동의를 받은 경우
    (예: 재가입 편의를 위한 일정 기간 보관 등)
- 「전자상거래 등에서의 소비자보호에 관한 법률」에 따른 보관
    - 계약 또는 청약철회 등에 관한 기록: 5년
    - 대금 결제 및 재화 등의 공급에 관한 기록: 5년
    - 소비자의 불만 또는 분쟁처리에 관한 기록: 3년
- 「통신비밀보호법」에 따른 접속기록 보관
    - 접속 로그, IP 등 서비스 이용 기록: 3개월

회사는 개인정보를 파기할 때 다음과 같은 절차와 방법을 따릅니다:

- 파기 절차: 수집 및 이용 목적이 달성된 개인정보는 내부 방침 및 관련 법령에 따라 지체 없이 파기되며, 파기 대상 여부를 사내 검토 후 삭제 처리합니다.
- 파기 방법: 전자적 파일 형태의 정보는 복구 및 재생이 불가능한 방식으로 영구 삭제합니다. 종이에 출력된 정보는 분쇄하거나 소각 등의 방법으로 안전하게 파기합니다.

제6조. 이용자의 권리 및 그 행사 방법

회사는 이용자의 개인정보 자기결정권을 존중하며, 이용자는 언제든지 자신의 개인정보에 대해 다음 각 호의 권리를 행사할 수 있습니다.

- 개인정보 열람 요구 : 프리플랍이 보유하고 있는 본인의 개인정보에 대해 열람을 요청할 수 있습니다.
- 개인정보 정정·삭제 요구: 개인정보가 사실과 다르거나 오류가 있는 경우, 이를 정정 또는 삭제해 줄 것을 요청할 수 있습니다. 단, 다른 법령에서 해당 개인정보의 보존을 명시하고 있는 경우에는 삭제를 요청할 수 없습니다.
- 개인정보 처리정지 요구: 개인정보의 처리 정지를 요청할 수 있으며, 회사는 특별한 사정이 없는 한 이를 즉시 중단합니다. 다만, 다음 각 호의 어느 하나에 해당하는 경우에는 처리정지 요청이 거절될 수 있습니다.
    1. 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우
    2. 제3자의 권익을 현저히 해칠 우려가 있는 경우
    3. 개인정보 처리가 불가능할 경우 해당 서비스 제공이 어려운 경우

제8조. 개인정보 보호책임자 및 담당자 안내

프리플랍은 이용자의 개인정보를 보호하고, 개인정보와 관련된 문의 및 불만 사항을 신속하고 성실하게 처리하기 위하여 아래와 같이 개인정보 보호책임자 및 담당자를 지정하고 있습니다.

개인정보 보호책임자

성명: [신선호]
소속/직위: [예: 프리플랍 운영팀 / 대표]
이메일: [aaaa@preflop.xyz]

기타 개인정보 침해에 대한 신고나 상담이 필요한 경우에 아래 기관에 문의 가능합니다.

개인정보분쟁조정위원회 : www.kopico.go.kr / (1833-6972)
개인정보침해신고센터 : privacy.kisa.or.kr / (118)
대검찰청 : www.spo.go.kr / (1301)
경찰청 : ecrm.police.go.kr / (182)
`